import dayjs from "dayjs";

export const useFormatter = () => {
  const formatDateTime = (value) => {
  	if (value == "" || value == null)
  	  return "";
  	return dayjs(value).format("YYYY-MM-DD HH:mm:ss");
  }
  return { formatDateTime };
};